var map = {
	"./ambassador-bg.webp": 1245,
	"./asset-2.png": 1246,
	"./btn-enter-bg.png": 1247,
	"./btn-enter-white-bg.webp": 1248,
	"./btn-more-bg.webp": 1249,
	"./casino-hover.webp": 1250,
	"./casino.webp": 1251,
	"./convenient.webp": 1252,
	"./es-bg.webp": 1253,
	"./event-sec-bg.webp": 1254,
	"./event-sport-bg.webp": 1255,
	"./fifa1-bg.jpg": 1256,
	"./fifa2-bg-cn.jpg": 1257,
	"./fifa2-bg.jpg": 1258,
	"./games-hover.webp": 1259,
	"./games.webp": 1260,
	"./gauge.webp": 1261,
	"./lottery-hover.webp": 1262,
	"./lottery.webp": 1263,
	"./master-bg.webp": 1264,
	"./p2p-hover.webp": 1265,
	"./p2p.webp": 1266,
	"./platform.webp": 1267,
	"./product-ctg-bg.webp": 1268,
	"./product-overview-bg.webp": 1269,
	"./professional.webp": 1270,
	"./safety.webp": 1271,
	"./slots-hover.webp": 1272,
	"./slots.webp": 1273,
	"./speed.webp": 1274,
	"./sports-hover.webp": 1275,
	"./sports.webp": 1276,
	"./video-bg.webp": 1277,
	"./wave.webp": 1278,
	"./wwr-bg.webp": 1279,
	"./wwr-img-b.webp": 1280,
	"./wwr-img.webp": 1281,
	"./wwr-subImg1.webp": 1282,
	"./wwr-subImg2.webp": 1283,
	"./wwr-subImg3.webp": 1284,
	"./x33-logo-cny.png": 1285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 458;